import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const SplitHorizontalIcon = createSvgIcon(
  <>
    <title>split horizontal</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="16"
        x2="16"
        y1="2"
        y2="30"
      />{' '}
      <line
        data-cap="butt"
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="20"
        x2="30"
        y1="16"
        y2="16"
      />{' '}
      <line
        data-cap="butt"
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="2"
        x2="12"
        y1="16"
        y2="16"
      />{' '}
      <polyline
        fill="none"
        points="24,22 30,16 24,10 "
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <polyline
        fill="none"
        points="8,22 2,16 8,10 "
        stroke="#222222"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
